import { css } from "../../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      textAlign: "center",
      borderRadius: "6px",
      width: "100%",
      height: "200px",
      color: "headlineGrey",
      backgroundColor: "backgroundGrey",
      paddingY: "baseUnit.mobile2",
      paddingX: "baseUnit.mobile1",
      letterSpacing: "body.horse",
      mobile: {
        padding: "baseUnit.mobile2",
        width: "154px",
        height: "236px",
      },
    }),
  label: () =>
    css({
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      height: "48px",
    }),
  valueGroup: () =>
    css({
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
    }),
  value: () =>
    css({
      fontSize: "heading.H2.mobile",
      lineHeight: "heading.H2.mobile",
      letterSpacing: "heading.H2.mobile",
      mobile: {
        fontSize: "heading.H2.desktop",
        lineHeight: "heading.H2.desktop",
        letterSpacing: "heading.H2.desktop",
      },
    }),
  adornmentWrapper: () =>
    css({
      position: "absolute",
      bottom: "-15px",
      left: 0,
      right: 0,
      textAlign: "center",
      lineHeight: "0.4",
      desktop: {
        bottom: "-5px",
      },
    }),
  hint: () =>
    css({
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
    }),
  linkContainer: () =>
    css({
      display: "flex",
      flexDirection: "column-reverse",
      height: "48px",
      "& a": {
        color: "oceanBlue",
        textDecorationColor: "oceanBlue",
        _hover: {
          color: "abyssBlue",
          textDecorationColor: "abyssBlue",
        },
      },
    }),
};
